'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.objects = exports.components = undefined;

var _components = require('./components');

var components = _interopRequireWildcard(_components);

var _objects = require('./objects');

var objects = _interopRequireWildcard(_objects);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.components = components;
exports.objects = objects;
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/video-asset/~/@spp/iris-prop-types/lib/cjs/index.js
 ** module id = 307
 ** module chunks = 1
 **/